/**
* @Author 22030124/xieyq
* @Date 2023-12-28 11:26:59
* @Description 人员选择公共js
*/
// 请求类
import Request from './request.js'
export default {
  // 参数
  props: {
    // 访问凭证(key)
    accessKey: {
      type: String
    },
    // 值
    value: {},
    // 是否置灰
    disabled: {
      type: Boolean
    },
    // 是否多选
    multiple: {
      type: Boolean
    },
    // 置灰的数组
    disabledKeys: {
      type: [Array],
      default: () => []
    },
    // 格式化方法
    normalizer: {
      type: Function,
      default: (node) => {
        return node
      }
    },
    // 标签
    label: {
      type: String,
      default: 'name'
    },
    // 值的key
    valueKey: {
      type: String,
      default: 'userEmpsn'
    },
    // 当前用户编码
    currentUserEmpsn: String
  },
  // 数据
  data() {
    return {
      // 请求url地址
      // 测试环境
      // action: 'https://gatewaytest.cosmoplat.com/SV000041',
      action: 'https://gateway.cosmoplat.com/SV000008',
      // 访问凭证(key)
      key: ''
    }
  },
  // 子级提供
  provide() {
    return {
      // 像child组件提供请求对象
      request: new Request(this.action, this.accessKey || this.key),
      // 当前用户
      currentUser: this.currentUserEmpsn
    }
  },
  // 创建
  created() {
    // 初始化方法
    this.commonInit()
  },
  // 方法
  methods: {

    /**
     * 初始化方法
     * @returns {void}
     */
    commonInit() {
      // 设置对应的请求
      this.request = new Request(this.action, this.accessKey || this.key)
    },

    /**
     * 获取选择的结果
     * @param {*} val 选择的值
     * @returns {void}
     */
    getResult(val) {
      let result
      // 如果多选
      if (this.multiple) {
        // 结果
        result = val.map(item => {
          // 如果id存在，则说明是组件带的
          if (this.isInner(item)) {
            return this.normalizer(item)
          }
          return item
        })
      } else {
        if (val?.id) {
          result = this.normalizer(val)
        } else {
          result = val
        }
      }
      return result
    },

    /**
     * 修改
     * @param {*} val
     */
    emitChange(val) {
      // 抛出修改事件
      this.$emit('change', val)
    },

    /**
     * 是否是内部节点
     * @param {*} node 节点数据
     * @returns {Boolean}
     */
    isInner(node) {
      return node.id && node.createdAt
    }
  }
}
